module.exports = __webpack_public_path__ + "images/help/icon-twr41-856ad821f172c00f3261190f72704d24.png";